<template>
  <div class="border_1 border_grey p-3 mt-3">
    <div class="">
      <b-row>
        <b-col cols="12" sm="4" class="text-alignment-mobile">
          <i
            class="mdi mdi-text-box-check-outline font_size_1250rem"
            aria-hidden="true" v-b-toggle="collapseId"
          />
          <span
            class="ml-3 text-decoration-none clickable v3_color_teal"
            v-b-toggle="collapseId"
          >
            {{ profile.title }}
          </span>
        </b-col>
        <b-col
          cols="12"
          sm="4"
          class="text-alignment-mobile d-flex align-items-center justify-content-center"
        >
          <span class="ml-1">
            <svg
              v-if="numberOfMatches"
              xmlns="http://www.w3.org/2000/svg"
              width="2em"
              height="2em"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path
                fill="#393"
                d="M21.4 7.5c.8.8.8 2.1 0 2.8l-2.8 2.8l-7.8-7.8l2.8-2.8c.8-.8 2.1-.8 2.8 0l1.8 1.8l3-3l1.4 1.4l-3 3l1.8 1.8m-5.8 5.8l-1.4-1.4l-2.8 2.8l-2.1-2.1l2.8-2.8l-1.4-1.4l-2.8 2.8l-1.5-1.4l-2.8 2.8c-.8.8-.8 2.1 0 2.8l1.8 1.8l-4 4l1.4 1.4l4-4l1.8 1.8c.8.8 2.1.8 2.8 0l2.8-2.8l-1.4-1.4l2.8-2.9Z"
              />
            </svg>
            &nbsp;&nbsp;{{ numberOfMatches }}
            {{ numberOfMatches === 1 ? 'match' : 'matches' }}
            <span class="no-wrap" v-if="isShowMatchesDetails">
              ({{ numberOfPerfectMatches }} perfect,
              {{ numberOfCoreMatches }} core)
            </span>
          </span>
        </b-col>
        <b-col
          cols="12"
          sm="4"
          class="text-alignment-mobile d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <template v-if="!profile.deleted">
            <b-button
              :to="`/exchange/job-profile/${profile.id}`"
              class="mr-3"
              variant="v3_link_teal"
            >
              Edit
            </b-button>
            <b-button
              class="d-flex align-items-center justify-content-center"
              variant="v3_link_red"
              @click="onDeleteJobProfile"
              :disabled="deleteLoading"
            >
              <template v-if="!deleteLoading">Delete</template>
              <template v-else>
                <b-spinner small />
              </template>
            </b-button>
          </template>
          <template v-else>
            <b-button
              class="d-flex align-items-center justify-content-center"
              variant="v3_link_teal"
              @click="onUnDeleteJobProfile"
              :disabled="deleteLoading"
            >
              <template v-if="!deleteLoading">Undelete</template>
              <template v-else>
                <b-spinner small />
              </template>
            </b-button>
          </template>
        </b-col>
      </b-row>
    </div>
    <b-collapse :id="collapseId" accordion="ico-cards">
      <b-row class="py-3 px-1 px-md-2 px-lg-4">
        <template v-if="matches.length === 0" >
        <b-col cols="12" class="py-4">
          There are no matches for this ICO at this time.
        </b-col>
        </template>
        <template  v-else>
        <b-col
          cols="12"
          v-for="(match, i) in matches"
          :key="match.id"
          :class="{ 'mt-3': i > 0 }"
        >
          <job-profile-job-offer-list-item
            ref="listItems"
            :job-profile="profile"
            :job-questions="jobQuestions"
            :match="match"
            @update-new-msg-count="updateNumberOfNewMsgs"
          />
        </b-col>
        </template>
      </b-row>
    </b-collapse>
  </div>
</template>

<script>
import JobProfileJobOfferListItem from '@/components/exchange/job-profiles-list/JobProfileJobOfferListItem';
import Help from '@/providers/Help';
import Api from '@/providers/Api';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import { JOB_OFFERS_MATCHING_STATUS } from '@/store';

export default {
  name: 'JobProfileCardV3',
  components: {
    JobProfileJobOfferListItem,
  },
  props: {
    profile: {
      type: Object,
      required: true,
    },
    jobQuestions: Array,
    isDeclinedMatches: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      deleteLoading: false,
      numberOfNewMessages: 0,
      declineLoading: false,
    };
  },
  mounted: function () {
    this.updateNumberOfNewMsgs();
  },
  computed: {
    collapseId: function () {
      return `job-profile-${this.profile.id}-${
        this.isDeclinedMatches ? 'd' : ''
      }`;
    },
    numberOfViews: function () {
      return Math.floor(Math.random() * 31);
    },
    numberOfMatches: function () {
      return this.matches.length || 0;
    },
    numberOfCoreMatches: function () {
      return (
        this.matches.filter(
          (match) => match.status === JOB_OFFERS_MATCHING_STATUS.CORE
        ).length || 0
      );
    },
    numberOfPerfectMatches: function () {
      return (
        this.matches.filter(
          (match) => match.status === JOB_OFFERS_MATCHING_STATUS.PERFECT
        ).length || 0
      );
    },
    isDemoMode: function () {
      return this.$store.getters.isDemoMode;
    },
    user: function () {
      return this.$store.state.user ? this.$store.state.user : {};
    },
    isDemoUser: function () {
      return !!this.user.is_demo;
    },
    matches: function () {
      return (this.profile.jobProfileJobOfferMatches || []).filter((match) => {
        return !!match.is_declined === this.isDeclinedMatches;
      });
    },
    isShowMatchesDetails: function () {
      //PHAIR-1292 temporary disabled
      return false;
    },
  },
  methods: {
    onDeleteJobProfile: function () {
      Help.confirm.show(
        'Are you sure you want to delete the Job Profile?',
        'Delete',
        () => {
          this.deleteJobProfile();
        }
      );
    },
    updateDeclineStatus: async function (isDeclined) {
      this.declineLoading = true;
      try {
        await Api.updateJobProfileDeclineStatus(this.profile.id, isDeclined);
        this.$emit(
          'update-job-profile-decline-status',
          this.profile.id,
          isDeclined
        );
      } catch (e) {
        handleServerErrorWithValidation(e, this.$toasted);
      } finally {
        this.declineLoading = false;
      }
    },
    deleteJobProfile: function () {
      this.deleteLoading = true;
      this.$emit('delete-job-profile', this.profile.id);
    },
    onUnDeleteJobProfile: function () {
      this.deleteLoading = true;
      this.$emit('undelete-job-profile', this.profile.id);
    },
    updateNumberOfNewMsgs: function () {
      if (!Array.isArray(this.$refs.listItems)) return;
      this.numberOfNewMessages = this.$refs.listItems.reduce((acc, item) => {
        if (item && item.numberOfUnviewedMessages) {
          acc += parseInt(item.numberOfUnviewedMessages);
        }
        return acc;
      }, 0);
    },
  },
};
</script>

<style scoped lang="scss">
.job-question-and-response-wrapper {
  margin-right: -40px;
}
.display-class {
  display: flex;
  justify-content: space-between;
}
@media (max-width: 576px) {
  .text-alignment-mobile {
    text-align: center !important;
  }
  .display-class {
    display: inline-flex;
  }
}
</style>
